import React from 'react';
import { userData } from '../../data';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const Profile = () => {
    useDocumentTitle('Profile | Jerel Layog');

    return (
        <section className="content-pane w-full h-full flex flex-col pt-16 md:pt-24 2xl:pt-44 overflow-y-auto custom-scrollbar px-4 sm:px-8 md:pl-16 2xl:pl-24 relative z-20" tabIndex={-1} aria-labelledby="heading-profile">
            <div className="relative mb-6 md:mb-10 2xl:mb-14 z-10 text-center md:text-left">
                <h1 id="heading-profile" className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl 2xl:text-[10rem] font-persona-menu text-white text-outline mb-2 2xl:mb-4 break-words">
                    {userData.name}
                </h1>
            <h2 className="text-lg sm:text-xl md:text-4xl 2xl:text-5xl font-black italic text-black bg-[#FFF200] inline-block px-3 md:px-4 2xl:px-6 py-1 md:py-2 2xl:py-3 border-4 md:border-[6px] 2xl:border-[8px] border-black md:ml-6 2xl:ml-10 shadow-[5px_5px_0_#000] md:shadow-[12px_12px_0_#000] 2xl:shadow-[19px_19px_0_#000]">
                {userData.title}
            </h2>
        </div>

        <div className="flex flex-col xl:flex-row gap-8 lg:gap-12 2xl:gap-16 items-center xl:items-start relative mx-auto md:mx-0 max-w-5xl 2xl:max-w-6xl pb-32 2xl:pb-40">
            <div className="relative shrink-0 w-48 h-48 sm:w-64 sm:h-64 lg:w-72 lg:h-72 xl:w-80 xl:h-80 2xl:w-96 2xl:h-96 transform -rotate-2 2xl:-rotate-3 hover:rotate-0 transition-transform duration-300 group z-20">
                <div className="absolute inset-0 bg-black transform translate-x-2.5 translate-y-2.5 md:translate-x-4 md:translate-y-4 2xl:translate-x-6 2xl:translate-y-6" aria-hidden="true"></div>
                <div className="relative bg-[#FFF200] border-4 md:border-[6px] 2xl:border-[8px] border-black w-full h-full overflow-hidden">
                    <img
                        src={userData.profileImage}
                        alt={userData.name}
                        className="w-full h-full object-cover grayscale contrast-125 mix-blend-multiply group-hover:grayscale-0 group-hover:mix-blend-normal transition-all duration-300"
                    />
                </div>
            </div>

            <div className="relative transform md:rotate-1 2xl:rotate-2 mt-4 xl:mt-0">
                <div className="absolute inset-0 bg-black transform translate-x-1.5 translate-y-1.5 md:translate-x-2.5 md:translate-y-2.5 2xl:translate-x-4 2xl:translate-y-4" aria-hidden="true"></div>
                <div className="relative bg-white p-6 sm:p-6 md:p-8 lg:p-10 2xl:p-12 border-4 md:border-[6px] 2xl:border-[8px] border-black">
                    {userData.about.split('\n\n').map((paragraph, i) => (
                        <p key={i} className="font-montserrat font-semibold md:font-bold text-xs sm:text-sm md:text-base lg:text-lg 2xl:text-xl leading-relaxed mb-3 md:mb-4 2xl:mb-6 last:mb-0 relative z-20">
                            {paragraph}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    </section>
    );
};

export default Profile;